export default "__VITE_ASSET__Diti3CkM__"